import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M19.093 9.848h-5.417l-1.674-5.153-1.674 5.153H4.91l4.383 3.184-1.674 5.152L12.002 15l4.383 3.184-1.675-5.152zm-8.573 2.785.566-1.742h1.832l.566 1.742-1.482 1.077zm2.059-2.785h-1.154l.577-1.776zm1.792 2.14-.356-1.097h1.867zM9.99 10.892l-.357 1.098-1.51-1.098zm-.385 4.562.577-1.776.933.678zm3.285-1.098.934-.678.577 1.776z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }